<template>
  <div class="wallpaper-container">
    <div class="logo">
      <b><span>D</span>EV.<span>D</span></b>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="postcss">
@import url('https://fonts.googleapis.com/css2?family=Vibur&display=swap');

.wallpaper-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.logo b {
  font:
    400 40px 'Vibur',
    cursive;
  color: #18181b;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.logo b span {
  animation: blink linear infinite 2s;
}

.logo b span:nth-of-type(2) {
  animation: blink linear infinite 3s;
}

@keyframes blink {
  78% {
    color: inherit;
    text-shadow: inherit;
  }
  79% {
    color: #9ca3af;
  }
  80% {
    text-shadow: none;
  }
  81% {
    color: inherit;
    text-shadow: inherit;
  }
  82% {
    color: #9ca3af;
  }
  83% {
    color: inherit;
    text-shadow: inherit;
  }
  92% {
    color: #9ca3af;
  }
  92.5% {
    color: inherit;
    text-shadow: inherit;
  }
}
</style>
